export * from '@remoov/devices/src/Web';

export * from '@remoov/functional';
export * from '@remoov/remoov-components';

export type ToastrType = unknown;
export type ItemPageLocation = {
  pathname: string;
  search: string | null | undefined;
  query: {
    pickupId: string | null | undefined;
    page: string | null | undefined;
    sort: string | null | undefined;
    status: Maybe<string>;
    categoryIds: Maybe<string>;
  };
};
export type ItemPageProps = {
  history: History;
  location: ItemPageLocation;
};
